module.exports = __webpack_public_path__ + "static/media/reports.28659aa6.svg";